
import React, { useMemo } from "react";
import { ResponsiveContainer, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LineChart } from 'recharts';
import { useTheme } from "@mui/material";

// Function to process data
// const processData = (data) => {
//   const orderCounts = {};

//   data.forEach((order) => {
//     const date = new Date(order.startTime).toISOString().split("T")[0]; // Extract YYYY-MM-DD
//     orderCounts[date] = (orderCounts[date] || 0) + 1;
//   });

//   return Object.keys(orderCounts).map((date) => ({
//     date,
//     count: orderCounts[date],
//   }));
// };

const OrdersChart = ({ chartData }) => {
  // console.log("OrdersChart received chartData:", chartData);
  const theme = useTheme();
  useMemo(() => {
    if (!chartData || chartData.length === 0) return [];

    // Initialize 24 hours with 0
    const hours = Array.from({ length: 24 }, (_, i) => ({
      hour: `${i.toString().padStart(2, "0")}:00`,
      current: 0
    }));

    chartData.forEach(order => {
      if (!order.startTime || !order.total) return;

      const orderDate = new Date(order.startTime);
      const hour = orderDate.getHours(); // get hour (0–23)

      hours[hour].current += order.total;
    });

    return hours;
  }, [chartData]);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        {chartData[0].current !== undefined && (
          <Line type="monotone" dataKey="current" stroke={theme.palette.primary.main} name="Current Week" strokeWidth={2} />
        )}
        {chartData[0].previous !== undefined && (
          <Line type="monotone" dataKey="previous" stroke={theme.palette.success.main} name="Previous Week" strokeWidth={2} />
        )}
        {/* Fallback rendering if data structure is simple (e.g., daily order count) */}
        {chartData[0].current === undefined && <Line type="monotone" dataKey={Object.keys(chartData[0])[1]} stroke={theme.palette.primary.main} strokeWidth={2} />}
      </LineChart>
    </ResponsiveContainer>
  );
};
export default OrdersChart;